import { getTemporaryToken, getTemporaryTokenTenantId } from '@/features/auth/auth.utils.js'
import { getActiveClubId } from '@/features/router/useActiveClub.js'

export const LOGOUT_FLOWS = {
  exitClub: 'exitClub',
  sessionExpired: 'sessionExpired',
  remoteLogout: 'remoteLogout',
}

export function buildLogoutRoute({ redirectUrl, logoutFlow } = {}) {
  const params = new URLSearchParams()
  const activeClubId = getActiveClubId() || getTemporaryTokenTenantId()

  if (activeClubId) {
    params.set('activeClubId', activeClubId)
  }

  if (redirectUrl) {
    params.set('redirectUrl', redirectUrl)
  }

  const resolvedLogoutFlow = logoutFlow || (getTemporaryToken() ? LOGOUT_FLOWS.exitClub : undefined)

  if (resolvedLogoutFlow) {
    params.set('logoutFlow', resolvedLogoutFlow)
  }

  const queryString = params.toString()
  return queryString ? `/auth/logout?${queryString}` : '/auth/logout'
}
